import {Navigate, Route, Routes} from "react-router-dom";
import React from "react";
import Login from "./Login";
import LoginOtp from "./LoginOtp";
import Register from "./Register";
import ForgetPassword from "./ForgetPassword";
import Unsplash from "./Unsplash";


export default function () {

    return <Unsplash>
        <Routes>
        <Route path="/" element={<Navigate to="/login"/>}/>
        <Route path="Login" element={<Login/>}/>
        <Route path="LoginOtp" element={<LoginOtp/>}/>
        <Route path="Register" element={<Register/>}/>
        <Route path="ForgetPassword" element={<ForgetPassword/>}/>
        <Route path="/*" element={<Navigate to="/login"/>}/>

    </Routes>
    </Unsplash>;

}

